import { useEffect } from 'react'

import {
  setUser,
  userDefaultSkins,
  userDefaultValues,
} from '@utsubo/experience'
import { setLoader } from '@utsubo/renderer'

import { useUser } from '@/helpers/firebase/api'
import { getSettings } from '@/api/settings'
import { setPublic } from '@/api/public'

import { firebaseNotificationHelpers } from '@/backend/firebaseNotificationHelpers'
import { consoleTimeTrack } from '../../consoleTimeTrack'
import { signInAnonymous } from './sign/signInAnonymous'
import { isAdmin } from '@/helpers/isAdmin'

const emoji = `🍥 `

const setupUserSession = async (user) => {
  setLoader({ fetchingText: 'fetching-data' })

  setUser({
    ...userDefaultValues,
    ...userDefaultSkins(),
    id: user.uid,
    isAdmin: isAdmin(user.uid),
    user,
    publicSet: false,
    hasDocument: false,
  })
  if (user.isAnonymous) {
    // insert dummy data to init the collection in firestore
    await setPublic({
      property: 'isAnonymous',
      value: true,
      userId: user.uid,
    })
  } else {
    setPublic({
      userId: user.uid,
      data: {
        isAnonymous: false,
        email: user.email,
      },
    })
    await getSettings(user.uid)
  }
  setUser({ hasDocument: true })
}

export function FirebaseLoginState({ children }) {
  const { loadingForTokenChange, data: user } = useUser()

  useEffect(() => {
    consoleTimeTrack('Trying to login', {
      fileName: 'FirebaseLoginState.jsx',
      methodName: 'useEffect',
    })

    // prevent anonymous login to override the token of a logged in user
    if (loadingForTokenChange) return

    if (user) {
      consoleTimeTrack(user, {
        fileName: 'FirebaseLoginState.jsx',
        methodName: 'useEffect',
      })

      setupUserSession(user).then(() => {
        setUser({ anonymousSession: user.isAnonymous, token: user.accessToken })
        consoleTimeTrack(
          `logged in as ${user.email} ${user.isAnonymous ? 'anonymous' : ''}`,
          { fileName: 'FirebaseLoginState.jsx', methodName: 'setupUserSession' }
        )

        firebaseNotificationHelpers.registerPushNotifications({
          user,
          vapidKey:
            'BHQT4VSCyDxqOpJDVvWP2RXlCHmWkN0TRtFfJKDx4BtYfW5T2-lbp-NOa8y8BO4KTg1XHa7Gc06viP-VFNuNHa4',
        })
      })
    } else {
      signInAnonymous()
    }
  }, [loadingForTokenChange, user])

  return <>{/* {children} */}</>
}
